import React from "react";
import logo from "../../assets/images/logo.png";
import menuLeft from "../../assets/images/menu-left.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useLocation } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

const AdminNav = () => {
  const { pathname } = useLocation();
  let validates = false;
  let user = JSON.parse(localStorage.getItem("LogUser"));
  let Fname = JSON.parse(localStorage.getItem("fname"));

  user ? (validates = true) : (validates = false);
  // Navbar titles
  const navArr = [
    { path: "/admin", title: "Dashboard" },
    { path: "/admin/testimonials", title: "Testimonial" },
    { path: "/admin/research", title: "Research" },
    { path: "/admin/manage-institute", title: "Manage Institutes" },
    { path: "/admin/editinfo", title: "Information" },
    { path: "/admin/userquery", title: "User Query" },
    { path: "/admin/award", title: "Awards" },
    // { path: "/admin/test", title: "Test" },
  ];

  const dropdownArr = [
    { path: "/admin/Contact", title: "Contact Us" },
    { path: "/admin/connect-with-us", title: "Social Media" },
    { path: "/admin/faq", title: "FAQ's" },
    { path: "/admin/blogs", title: "Blogs" },
    { path: "/admin/announcement", title: "Announcement" },
    { path: "/admin/portal-usage-report", title: "Portal Usage Report" },
  ];

  return (
    <>
      {/* Old Navbar Code */}
      <header>
        <nav className="navbar navbar-expand-md main-header-section">
          <div className="container-fluid">
            <a
              className="navbar-brand"
              href="/#"
              onClick={(e) => e.preventDefault()}
            >
              <div className="logoContent ">
                <img src={logo} alt="" className="img-fluid" />
              </div>
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mynavbar"
            >
              <img src={menuLeft} alt="" />
            </button>
            <div className="collapse navbar-collapse" id="mynavbar">
              <ul className="navbar-nav ms-auto">
                {navArr.map((item, index) => {
                  return (
                    <li
                      key={index}
                      className={
                        item.path === pathname
                          ? "nav-item text-underline"
                          : "nav-item"
                      }
                    >
                      <Link className="nav-link " to={item.path}>
                        {item.title}
                      </Link>
                    </li>
                  );
                })}
                <li className="nav-item">
                  <Dropdown className="award-dropdown cstm-award-drpdwn">
                    <Dropdown.Toggle
                      variant="transparent"
                      id="dropdown-basic"
                      className="fw-medium"
                    >
                      Get in Touch
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="cstm-nav-link">
                      {dropdownArr.map((item, index) => (
                        <Dropdown.Item
                          key={index}
                          as={Link}
                          to={item.path}
                          className={
                            location.pathname === item.path
                              ? "nav-item subActive  "
                              : ""
                          }
                        >
                          {item.title}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              </ul>

              <div className="userTop ms-auto">
                <div className="dropdown">
                  {validates ? (
                    <>
                      <button
                        type="button"
                        className="btn dropdown-toggle"
                        data-bs-toggle="dropdown"
                      >
                        <span>{Fname}</span>
                      </button>
                      <ul className="dropdown-menu">
                        <Link className="dropdown-item" to="/logout">
                          Logout
                        </Link>
                      </ul>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* New Navbar code */}
      {/* <section class="header_wrapper">
        <div class="container">
          <nav class="navbar navbar-expand-lg navbar-light">
            <div class="container-fluid">
              <a class="navbar-brand" href="#">
                <img src={logo} alt="logo" />
              </a>
              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mx-auto nav_item_wrap gap-2">
                  {navArr.map((item, index) => {
                    return (
                      <li
                        key={index}
                        className={
                          item.path === pathname
                            ? "nav-item text-underline"
                            : "nav-item"
                        }
                      >
                        <Link className="nav-link " to={item.path}>
                          {item.title}
                        </Link>
                      </li>
                    );
                  })}

                  <li class="nav-item dropdown list_dropdown">
                    <a
                      class="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span>{Fname}</span>
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                      <li>
                        <Link className="dropdown-item" to="/logout">
                          Logout
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </section> */}
    </>
  );
};

export default AdminNav;
